import { render, staticRenderFns } from "./IconSuccess.vue?vue&type=template&id=1376be8e&scoped=true"
var script = {}
import style0 from "./IconSuccess.vue?vue&type=style&index=0&id=1376be8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1376be8e",
  null
  
)

export default component.exports